import { hot } from 'react-hot-loader';
import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
import { Router } from './router';
import { RevolusendProvider } from './context';
import { DatePickerProvider } from './components/datePicketProvider';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';


let theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Montserrat',
      'sans-serif'
    ].join(','),
    subtitle1: {
      fontWeight: 600,
    },
    fontSize: 16

  },
  palette: {
    background: {
      default: 'transparent'
    },
    type: 'light',
    primary: {
      light: '#CF0E10',
      main: '#CF0E10',
      dark: '#CF0E10',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#CF0E10',
      main: '#CF0E10',
      dark: '#CF0E10',
      contrastText: '#ffffff',
    },
  },
});
theme = responsiveFontSizes(theme);

const App = () => (
  <React.Fragment>
    <DatePickerProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RevolusendProvider>
          {process.env.RECAPTCHA_KEY &&
            <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_KEY ?? ''}>
              <Router />
            </GoogleReCaptchaProvider>
          }
          {!process.env.RECAPTCHA_KEY &&
            <Router />
          }
        </RevolusendProvider>
      </ThemeProvider>
    </DatePickerProvider >
  </React.Fragment>
)

export default hot(module)(App);
